export default __webpack_public_path__ + "static/sushi-presentation-e347d8e23eb34c7e742259365c5ab3d4.png";